<div class="container d-flex flex-column justify-content-center align-items-center h-100 w-100">
  <img class="w-px-100 h-px-100" src="/assets/img/backgrounds/access-denied-img.png" alt="Access Denied Image" >
  <h2 class=" fw-bolder fa-lg m-3">Access Denied</h2>
  <p class="text-muted m-0">You do not have permission to view this page</p>
  <p *ngIf="isOwner" class="text-muted m-0">Please check your credentials and try again</p>
  <div *ngIf="isOwner">
    <h5 class="d-lg-flex justify-content-center align-content-center align-items-center gap-2 mt-3">
      <div>Please <a href="https://sadinhub.com/contact/" target="_blank" class="fw-bold">contact us</a> to get this module </div>
      <i class="fa-duotone fa-solid fa-phone text-success d-none d-md-block"></i>
    </h5>
  </div>
  <div *ngIf="!isOwner">
    <h5 class="d-flex justify-content-center align-content-center align-items-center gap-2 mt-3">
      <div>Please contact your admin to get the right permission </div>
    </h5> 
  </div>
  <h5 class="text-muted text-center mt-1">You will be redirected to the homepage in {{ countdown }}s</h5>
</div>